import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import Checkbox from "../Checkbox/Checkbox";
import Modal, { ModalProps } from "./Modal";
import Center from "../Base/Center";

export interface ConfirmationProps extends ModalProps {
  onSuccess: () => void;
  isPending?: boolean;
  title?: string;
  description?: string;
  disableCheckbox?: boolean;
  confirmButton?: string;
  swapButton?: boolean;
}

const Confirmation = ({
  isPending = false,
  confirmButton = "delete",
  title = "undoableMessage",
  description = "confirmationCheckboxMessage",
  disableCheckbox = false,
  swapButton = false,
  onSuccess,
  ...props
}: ConfirmationProps) => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(false);
  return (
    <Modal className="md:w-180" {...props}>
      <div className="text-center p-[2rem]">
        <div className="mb-6 text-3xl font-semibold">{t(title)}</div>
        <div className="mb-8">{t(description)}</div>

        {!disableCheckbox && (
          <Center className="mb-12">
            <Checkbox
              active={checked}
              onClick={() => setChecked(!checked)}
              checked={checked}
            >
              {t(description)}
            </Checkbox>
          </Center>
        )}
        <div
          className="flex justify-center gap-4"
          style={{ flexDirection: swapButton ? "row-reverse" : "row" }}
        >
          <Button
            isDisabled={disableCheckbox ? false : !checked}
            isPending={isPending}
            variant={swapButton ? "default" : "danger"}
            onClick={
              disableCheckbox
                ? onSuccess
                : checked === true
                  ? onSuccess
                  : undefined
            }
          >
            {t(confirmButton)}
          </Button>

          <Button
            variant={swapButton ? "danger" : "default"}
            onClick={props.onExit}
          >
            {t("cancel")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default Confirmation;
